const US_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-us';
const CA_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-ca';
const EU_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-eu';
const EUR_EU_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-eu-eur';

export function reverbPaymentsImageStyleClass({ bankCountryCode, shopCurrency }: { bankCountryCode: string; shopCurrency: string }) {
  if (shopCurrency === 'EUR') {
    return EUR_EU_RP_LABEL_IMAGE_CLASS;
  }

  if (shopCurrency === 'USD' && bankCountryCode === 'US') {
    return US_RP_LABEL_IMAGE_CLASS;
  }

  if (shopCurrency === 'CAD') {
    return CA_RP_LABEL_IMAGE_CLASS;
  }

  return EU_RP_LABEL_IMAGE_CLASS;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/reverb_payments_image.ts